import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";


export class AncientTreasureExchangeConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(AncientTreasureExchangeConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(AncientTreasureExchangeConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._currencyTo = null;
        this._currencyFrom = null;
        this._amount = 0;
    }

    get currencyTo() {
        return this._currencyTo;
    }

    set currencyTo(value) {
        this._currencyTo = value;
    }

    get currencyFrom() {
        return this._currencyFrom;
    }

    set currencyFrom(value) {
        this._currencyFrom = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    valid() {

        if (!CurrencyKindModel.is(this.currencyTo)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.currencyFrom)) {
            return false;
        }

        if (!Number.isInteger(this.amount) || this.amount <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return this.amount <= 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AncientTreasureExchangeConfig());
        } else if (target instanceof AncientTreasureExchangeConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AncientTreasureExchangeConfig, {
    _currencyTo: alias("currency_to", CurrencyKindModel.schema()),
    _currencyFrom: alias("currency_from", CurrencyKindModel.schema()),
    _amount: alias("amount", Schema.primitive())
});